import { render, staticRenderFns } from "./DebtPL_List.vue?vue&type=template&id=9d0593a0"
import script from "./DebtPL_List.vue?vue&type=script&lang=js"
export * from "./DebtPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports